<template>
    <section>
        <div id="branch_order_view_model" class="modal fade" role="dialog" ref="viewOrderModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                        <h4 class="modal-title">
                            <b class="pull-left">Order #: {{ order.id }}</b>
                            <b class="pull-right">Current Status:
                                <span
                                    v-if="order.statusesByStatusId"
                                    v-bind:class="'label ' + order.statusesByStatusId.cssClass">{{
                                        order.statusesByStatusId.name
                                    }}</span>
                                <span v-else>
                                    N/A
                                </span>
                            </b>

                        </h4>
                        <br/>
                    </div>
                    <div class="modal-body">
                        <OrderActions v-if="showOrderActions" :cancel-reasons="cancelReasons" :riders="ridersOfBranch" :sendCancellationNotification="true" @updateOrders="$emit('updateOrders')" :order="order" />
                        <div v-if="order.orderTypesByOrderTypeId.id === 1">
                          <div class="text-center text-danger">
                            <h2>
                              <strong>TAKE AWAY ORDER</strong>
                            </h2>
                          </div>
                        </div>
                        <legend>Customer Details</legend>
                        <address v-if="order.customerAddressesByCustomerAddressId">
                            <strong>{{ order.customerAddressesByCustomerAddressId.customersByCustomerId.name }}</strong><br/>
                            <span v-if="order.customerAddressesByCustomerAddressId.customersByCustomerId.email !== null"
                                  title="Email">Email: </span>
                            <b>{{
                                    (order.customerAddressesByCustomerAddressId.customersByCustomerId.email) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.email : 'N/A'
                                }}</b><br/>
                            <span v-if="order.orderTypesByOrderTypeId.id === 3">
                                Address: <b>{{ order.customerAddressesByCustomerAddressId.address }}</b><br/>
                                Area: <b>{{ order.customerAddressesByCustomerAddressId.areasByAreaId.name }}</b><br/>
                                City: <b>{{
                                    order.customerAddressesByCustomerAddressId.areasByAreaId.citiesByCityId.city
                                }}</b><br/>
                            </span>
                            <span v-else><b>Take Away Order</b></span>
                            <div class="row">
                                <div class="col-md-4">
                                    <abbr title="Phone">Phone-1:&nbsp;</abbr>
                                    <b>{{
                                            (order.customerAddressesByCustomerAddressId.customersByCustomerId.contact1) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.contact1 : 'N/A'
                                        }}</b>
                                </div>
                                <div class="col-md-4">
                                    <abbr title="Phone">Phone-2:&nbsp;</abbr>
                                    <b>{{
                                            (order.customerAddressesByCustomerAddressId.customersByCustomerId.contact2) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.contact2 : 'N/A'
                                        }}</b>
                                </div>
                                <div class="col-md-4">
                                    <abbr title="Phone">Phone-3:&nbsp;</abbr>
                                    <b>{{
                                            (order.customerAddressesByCustomerAddressId.customersByCustomerId.contact3) ? order.customerAddressesByCustomerAddressId.customersByCustomerId.contact3 : 'N/A'
                                        }}</b>
                                </div>
                            </div>
                        </address>
                      <address v-else>
                        <strong>{{ order.dvmAddress.dvmCustomer.name }}</strong><br/>
                        <span v-if="order.dvmAddress.dvmCustomer.email !== null"
                              title="Email">Email: </span>
                        <b>{{
                            (order.dvmAddress.dvmCustomer.email) ? order.dvmAddress.dvmCustomer.email : 'N/A'
                          }}</b><br/>
                        <span v-if="order.orderTypesByOrderTypeId.id === 3">
                                Address: <b>{{ order.dvmAddress.address}}</b><br/>
                                City: <b>{{
                            order.dvmAddress.citiesByCityId.city
                          }}</b><br/>
                            </span>
                        <span v-else><b>Take Away Order</b></span>
                        <div class="row">
                          <div class="col-md-4">
                            <abbr title="Phone">Phone:&nbsp;</abbr>
                            <b>{{
                                order.dvmAddress.dvmCustomer.contactNumber !== null && order.dvmAddress.dvmCustomer.contactNumber !== "" ? order.dvmAddress.dvmCustomer.contactNumber : "N/A"
                              }}</b>
                          </div>
                        </div>
                      </address>
                        <legend>Order Items
                            <span v-if="order.orderTypesByOrderTypeId.id === $orderType.DELIVERY.id">
                                ({{
                                    order.id === 0 ? 'Distance to cover by Rider' : 'Distance Covered By Rider'
                                }}: <span
                                class="badge badge-info">{{ order.totalDistance }}</span> Km)
                            </span>
                        </legend>
                        <table class="table table-bordered table-hover table-stripped">
                            <thead>
                            <tr>
                                <th class="text-center">Name</th>
                                <th class="text-center">Serving</th>
                                <th class="text-center">Price</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-center">Total Price</th>
                                <th class="text-center">Special Instruction</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-for="(orderItem, orderItemIndex) in order.orderItemsById">
                                <tr v-bind:key="orderItemIndex+'_'+orderItem.id">
                                    <td class="text-center">
                                        {{ orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name }}
                                    </td>
                                    <td class="text-center">{{ orderItem.menuItemTypesByMenuItemTypeId.serving }}</td>
                                    <td class="text-center">{{ orderItem.menuItemTypesByMenuItemTypeId.price }}</td>
                                    <td class="text-center">{{ orderItem.quantity }}</td>
                                    <td class="text-center">{{ orderItem.totalPrice }}</td>
                                    <td class="text-center text-danger">
                                        {{ orderItem.instructions ? orderItem.instructions : 'N/A' }}
                                    </td>
                                </tr>
                                <template v-for="(itemAddOn, index) in orderItem.orderItemAddOnsById">
                                    <tr v-bind:key="index+'_'+orderItemIndex+'_'+itemAddOn.addOnItemsByAddOnItemId.name">
                                        <td colspan="3" class="text-right"><b>Add On</b></td>
                                        <td class="text-center">{{ itemAddOn.addOnItemsByAddOnItemId.name }}</td>
                                        <td class="text-center">{{itemAddOn.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.name}}</td>
                                        <td class="text-center">
                                            {{
                                                (itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price) + ' => (' + itemAddOn.addOnItemsByAddOnItemId.price + ' X ' + itemAddOn.quantity + ')'
                                            }}
                                        </td>
                                    </tr>
                                </template>
                            </template>
                            <tr>
                                <td colspan="5" class="text-right">Sub Total</td>
                                <td class="text-right">{{ order.totalPrice | formatNumber }} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Sub Total With AdOn'S</td>
                                <td class="text-right">{{ order.totalPriceWithAddon | formatNumber }} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Tax Amount <b
                                    v-if="order.paymentMethod!==null && order.paymentMethod==='cash'" class="text-info">({{
                                        order.branchesByBranchId.tax
                                    }}%)</b><b
                                    v-if="order.paymentMethod!==null && order.paymentMethod==='card'" class="text-info">({{
                                        order.branchesByBranchId.cardTax
                                    }}%)</b>
                                </td>
                                <td class="text-right">
                                    {{
                                        Math.round((this.order.totalPriceAfterTax + this.order.discount) - this.order.totalPriceWithAddon)
                                    }}
                                    Rs.
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Sub Total After Tax</td>
                                <td class="text-right">{{ order.totalPriceAfterTax | formatNumber }} Rs.</td>
                            </tr>
                            <tr v-if="order.branchesByBranchId.freeDelivery">
                                <td colspan="4" class="text-right">Delivery Fee</td>
                                <td><b class="label label-danger">Not Charged To Customer</b></td>
                                <td class="text-right">{{ order.deliveryFee | formatNumber }} Rs.</td>
                            </tr>
                            <tr v-else>
                                <td colspan="5" class="text-right">Delivery Fee</td>
                                <td class="text-right">{{ order.deliveryFee | formatNumber }} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Discount <b v-if="order.couponsByCouponId!==null"
                                                                               class="text-info">({{
                                        (order.couponsByCouponId.inPercentage) ? order.couponsByCouponId.discount + "%" : order.couponsByCouponId.discount + ".RS"
                                    }}) </b></td>
                                <td class="text-right">{{ order.discount | formatNumber }} Rs.</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Billed Price</td>
                                <td class="text-right">{{ order.billedPrice | formatNumber }} Rs.</td>
                            </tr>
                            <tr v-if="order.paymentMethod!==null">
                                <td colspan="5" class="text-right">Payment Method</td>
                                <td class="text-right">{{ order.paymentMethod.name }}</td>
                            </tr>
                            <tr>
                                <td colspan="5" class="text-right">Payment Status</td>
                                <td class="text-right">{{ order.paymentStatus.name }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <legend>Order Wide Instructions</legend>
                        <span class="text-danger"><b>{{ order.orderWideInstructions }}</b></span>
                        <br/><br/>
                        <legend>Warehouse</legend>
                        <span>Name: <b>{{ order.branchesByBranchId.restaurantsByRestaurantId.name }}</b></span><br/>
                        <span>Vendors: <b>{{ order.branchesByBranchId.areasByAreaId.name }}</b></span><br/>
                        <br/><br/>
                        <div class="col-md-4 pull-right" v-if="order.ridersByRiderId">
                            <div>
                                <legend>Assigned Rider</legend>
                                <span>Name: <b>{{ order.ridersByRiderId.name }}</b></span><br>
                                <span>Contact Number: <b>{{ order.ridersByRiderId.contact }}</b></span><br>
                                <span>Vehicle Number: <b>{{ order.ridersByRiderId.vehicleNumber }}</b></span>
                            </div>
                        </div>
                        <legend>Estimated Delivery Time:
                            {{ order.expectedDeliveryMinutes ? order.expectedDeliveryMinutes + ' Min' : "N/A" }}
                        </legend>
                        <br/><br/>
                        <legend>Order History Status {{ order.orderHistoriesById.length > 0 ? '' : ": N/A" }}</legend>
                       <table class="table table-bordered table-hover table-condensed">
                           <head>
                               <tr>
                                   <th class="text-center">Status</th>
                                   <th class="text-center">Created</th>
                                   <th class="text-center">User</th>
                               </tr>
                           </head>
                           <tbody>
                           <tr v-for="(history, hIndex) in order.orderHistoriesById"
                               v-bind:key="'historyKey'+history.created +'_'+ hIndex">
                               <td class="text-center">
                                   <span
                                       v-bind:class="'label ' + history.statusesByStatusId.cssClass">{{
                                           history.statusesByStatusId.name
                                       }}</span>
                               </td>
                               <td class="text-center">
                                   <span
                                       v-bind:class="'label ' + history.statusesByStatusId.cssClass">{{
                                           history.statusesByStatusId.name === 'CREATED' ? $moment.parseZone(String(history.posCreated)).local().format('DD/MM/YYYY hh:mm:ss A') : $moment.parseZone(String(history.created)).local().format('DD/MM/YYYY hh:mm:ss A')
                                       }}</span>
                               </td>
                               <td class="text-center" >
                                        <span v-bind:class="'label ' + history.statusesByStatusId.cssClass" >
                                          {{ history.usersByUserId !== null ? history.usersByUserId.fullName : "Auto Assigned"}}
                                        </span>
                               </td>
                           </tr>
                           </tbody>
                       </table>
                        <section v-if="order.statusesByStatusId && order.statusesByStatusId.id === 9">
                            <br/><br/>
                            <legend>Cancel Reasons</legend>
                            <label><b
                                class="text-danger">{{
                                    (order.orderCancellationReasonsId.id === 4) ? order.otherCancelReasons : order.orderCancellationReasonsId.reason
                                }}</b></label>
                        </section>

                    </div>
                    
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div><!-- /.modal -->

    </section>
</template>

<script>
import OrderActions from "./OrderActions";
export default {
    name: "ViewOrder",
    components: {
        OrderActions
    },
    props: {
        showOrderActions: {
            type: Boolean,
            required: true
        }
    },
    data: function () {
        return {
            actionBtnLoadingClass: "",
            cancelReasons: [],
            ridersOfBranch: [],
            reRenderOrder: 0,
            order: {
                "id": 0,
                "totalPrice": 9654,
                "discount": 25,
                "billedPrice": 783,
                "created": "2018-11-03T19:00:00.000+0000",
                "modified": "2018-11-03T19:00:00.000+0000",
                "deliveryFee": 100,
                "cancelReasons": null,
                "commission": null,
                "totalDistance": 5,
                "totalPriceAfterTax": 783,
                "totalPriceWithAddon": 650,
                "pushTries": 1,
                "complaints": [],
                "table": {
                    "id": "",
                    "name": ""
                },
                "waiter": {
                    "name": ""
                },
                "orderHistoriesById": [
                    {
                        "created": "2018-11-03T19:00:00.000+0000",
                        "statusesByStatusId": {
                          "id": 10,
                          "name": "READY FOR DELIVERY",
                          "cssClass": "label-info"
                        },
                        "usersByUserId": {
                          "branch": null,
                          "contact": "",
                          "email": "",
                          "fullName": "",
                          "id": 0,
                          "restaurant": null,
                          "username": "",
                        }
                    }
                ],
                "orderItemsById": [
                    {
                        "id": 1,
                        "quantity": 1,
                        "totalPrice": 650,
                        "instructions": "These are ins",
                        "orderItemAddOnsById": [
                            {
                                "id": 1,
                                "quantity": 2,
                                "addOnItemsByAddOnItemId": {
                                    "id": 1,
                                    "name": "Pepsi",
                                    "price": 55,
                                    "addOnCategoriesByAddOnCategoryId": {
                                        "name": "Fries & Drinks",
                                        "allowedItems": 1
                                    }
                                }
                            }
                        ],
                        "menuItemTypesByMenuItemTypeId": {
                            "price": 199,
                            "serving": "1 Bucket",
                            "menuItemsByMenuItemId": {
                                "id": 145,
                                "name": "Hot Cowgirl",
                                "description": "Masala Fries\n",
                                "menuCategoriesByMenuCategoryId": {
                                    "name": "FRIES"
                                }
                            }
                        }
                    }
                ],
                "branchesByBranchId": {
                    "freeDelivery": true,
                    "tax": 16,
                    "restaurantsByRestaurantId": {
                        "name": "Howdy"
                    },
                    "areasByAreaId": {
                        "name": "Johar Town Block R3",
                        "citiesByCityId": {
                            "city": "Lahore"
                        }
                    }
                },
                "statusesByStatusId": {
                    "id": 0,
                    "name": "",
                    "cssClass": "label-success"
                },
                "customerAddressesByCustomerAddressId": {
                    "address": "House # 261, B - Block, Valencia Town.",
                    "customersByCustomerId": {
                        "name": "Salman Youasf",
                        "contact1": "03214948660",
                        "contact2": null,
                        "contact3": null,
                        "email": "salman.yousaf47@gmail.com"
                    },
                    "areasByAreaId": {
                        "name": "Valencia Town Block B1",
                        "citiesByCityId": {
                            "city": "Lahore"
                        }
                    }
                },
                "couponsByCouponId": null,
                "usersByUserId": {
                    "id": 50,
                    "username": "splashing75",
                    "fullName": "New Salman Yousaf",
                    "contact": "032196385245",
                    "email": "salman.yousaf@septemsystems.com"
                },
                "orderTypesByOrderTypeId": {
                    "type": "Delivery"
                },
                "paymentMethod": {
                    "id": '',
                    "name": ''
                },
                "paymentStatus": {
                    "id": '',
                    "name": ''
                }
            },
            punchOrderButton: false
        }
    },
    methods: {
        fetchOrderDetail: function (orderId) {
            let params = new URLSearchParams();
            params.append('order_id', orderId);
            this.$http.post(this.$store.state.mainAppURL + "orders/get_order_detail", params).then((response) => {
                this.order = response.data;
                if(this.order.dvmAddress !== null && this.order.dvmAddress.dvmCustomer.deleted){
                  let contactNo = this.order.dvmAddress.dvmCustomer.contactNumber;
                  this.order.dvmAddress.dvmCustomer.contactNumber = contactNo.split("&")[0];
                }
                // eslint-disable-next-line no-undef
                $("#branch_order_view_model").modal("show");
                this.fetchAllCancelReasons();
                if(this.order.statusesByStatusId.id === this.$status.ACCEPTED_BY_BRANCH.id && this.order.orderTypesByOrderTypeId.id === this.$orderType.DELIVERY.id) {
                    this.fetchRidersOfBranch();
                }
            }).catch(function (error) {
                console.log(error);
                this.showErrorMessage(error);
            });
        },
        async fetchAllCancelReasons () {
            if(this.order && this.order.statusesByStatusId.id === this.$status.ASSIGNED_TO_BRANCH.id) {
                try {
                    const { data } = await this.$http.get(this.$store.state.mainAppURL + 'orders/get_all_order_cancellation_reasons')
                    this.cancelReasons = data.filter(
                        cancelReason => (cancelReason.id !== 5 && cancelReason.id !== 6)
                    );
                } catch (e) {
                    console.error(e)
                }
            }
        },
        async fetchRidersOfBranch () {
            try {
                const { data } = await this.$http.get(this.$store.state.mainAppURL + "riders/?branch_id=" + this.$store.state.user.branch.id);
                this.ridersOfBranch = data
            } catch (e) {
                // eslint-disable-next-line no-undef
                this.showErrorMessage(e);
                console.error(e)
            }
        }
    }
}
</script>

<style scoped>
.modal { overflow: auto !important; }
</style>
